<template>
  <CarouselCard class="trendsreport-carousel-card" :class="getCardClass">
    <div v-if="isNew" class="trendsreport-carousel-card__new-flag">NEW</div>
    <div v-if="isAnnouncement" class="trendsreport-carousel-card__body">
      <div
        class="trendsreport-carousel-card__body-content"
        @click="$emit('item-selected', item, parentSlug)"
      >
        <h3
          v-if="item.title"
          class="trendsreport-carousel-card__announcement-title"
          :class="isNew ? 'new' : ''"
        >
          {{ item.title }}
        </h3>
        <p class="trendsreport-carousel-card__announcement-publish-date">
          {{ getDisplayDate }}
        </p>
        <p
          class="trendsreport-carousel-card__description"
          v-html="item.trimmed_description"
        />
        <p class="trendsreport-carousel-card__announcement-link">
          read article
        </p>
      </div>
    </div>
    <div v-else-if="!isArticle">
      <div
        class="trendsreport-carousel-card__image-container"
        :class="getCardClass"
        @click="
          isAcademy
            ? openAttachment()
            : $emit('item-selected', item, parentSlug)
        "
        @mouseover="isHoveringLock = true"
        @mouseleave="isHoveringLock = false"
      >
        <div
          :class="
            showPlayButton
              ? 'trendsreport-carousel-card__play-button-overlay trendsreport-carousel-card__play-button-overlay-visible'
              : 'trendsreport-carousel-card__play-button-overlay trendsreport-carousel-card__play-button-overlay-hidden'
          "
        >
          <img
            src="/images/play-icon.png"
            alt="Play Button"
            class="trendsreport-carousel-card__play-button-overlay-icon"
          />
        </div>
        <div
          v-if="!isQA"
          :class="
            showPopOut
              ? 'trendsreport-carousel-card__play-button-overlay trendsreport-carousel-card__play-button-overlay-visible'
              : 'trendsreport-carousel-card__play-button-overlay trendsreport-carousel-card__play-button-overlay-hidden'
          "
        >
          <img
            src="/images/pop-out.png"
            alt="Pop Out Button"
            class="trendsreport-carousel-card__play-button-overlay-icon"
          />
        </div>
        <img
          v-if="item.image"
          :src="item.image"
          :alt="item.title"
          class="trendsreport-carousel-card__image"
        />
        <div v-if="isNew" class="trendsreport-carousel-card__new-flag">NEW</div>
      </div>
      <div class="trendsreport-carousel-card__body">
        <div class="trendsreport-carousel-card__body-content">
          <div v-if="isAcademy" class="academy">
            <div>
              <h3
                class="trendsreport-carousel-card__title"
                @click="openAttachment()"
              >
                {{ item.title }}
              </h3>
            </div>
            <div>
              <BaseButton
                v-if="item.button && isAcademy"
                @click="openAttachment()"
                class="trendsreport-carousel-card__academy-button"
              >
                {{ item.button }}
              </BaseButton>
            </div>
          </div>
          <div v-else>
            <h3
              v-if="item.title"
              :class="
                isArticle
                  ? 'trendsreport-carousel-card__article-title'
                  : 'trendsreport-carousel-card__title'
              "
              @click="$emit('item-selected', item, parentSlug)"
            >
              {{ item.title }}
            </h3>
            <p
              v-if="!isAcademy"
              class="trendsreport-carousel-card__publish-date"
            >
              {{ getDisplayDate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="trendsreport-carousel-card__article-body">
      <div
        class="trendsreport-carousel-card__article-content"
        @click="$emit('item-selected', item, parentSlug)"
      >
        <h3 class="trendsreport-carousel-card__article-title">
          {{ item.title }}
        </h3>
        <p
          class="trendsreport-carousel-card__article-description"
          v-html="item.short_description"
        />
        <div class="trendsreport-carousel-card__article-image-container">
          <img
            :src="item.image"
            class="trendsreport-carousel-card__article-image"
          />
          <div
            v-if="isAtAGlanceArticle"
            class="trendsreport-carousel-card__article-image-overlay"
          />
          <div
            v-if="isAtAGlanceArticle"
            class="trendsreport-carousel-card__article-image-play-button"
          >
            <img
              src="/images/play-icon.png"
              alt="Play Button"
              class="trendsreport-carousel-card__article-image-play-button-icon"
            />
          </div>
        </div>
      </div>
      <div class="trendsreport-carousel-card__article-footer">
        <div class="trendsreport-carousel-card__article-date">
          {{ getDisplayDate }}
        </div>
        <div
          class="trendsreport-carousel-card__article-icon"
          :class="hasNotifications ? 'active' : ''"
          @click="handleAlert"
        >
          <BaseTooltip
            :fromTrendsReport="true"
            placement="top"
            xAlign="center"
            yAlign="top"
            contentWidth="fit-content"
            :fromArticle="true"
            class="trendsreport-carousel-card__article-tooltip"
            tooltipColor="white"
          >
            <template #display>
              <span
                class="icon-notification"
                :class="hasNotifications ? 'active' : 'inactive'"
              ></span>
            </template>
            <template #tooltip>
              <p>
                {{
                  hasNotifications
                    ? 'Turn Off Notifications'
                    : 'Receive Notifications'
                }}
              </p>
            </template>
          </BaseTooltip>
        </div>
        <div
          class="trendsreport-carousel-card__article-icon star"
          :class="isFavorite ? 'active' : ''"
          @click="handleFavorite"
        >
          <BaseTooltip
            :fromTrendsReport="true"
            placement="top"
            xAlign="center"
            yAlign="top"
            contentWidth="fit-content"
            :fromArticle="true"
            class="trendsreport-carousel-card__article-tooltip"
            tooltipColor="white"
          >
            <template #display>
              <span
                class="icon-star"
                :class="isFavorite ? 'active' : 'inactive'"
              ></span>
            </template>
            <template #tooltip>
              <p>
                {{ isFavorite ? 'Remove from Favorites' : 'Add to Favorites' }}
              </p>
            </template>
          </BaseTooltip>
        </div>
      </div>
    </div>
  </CarouselCard>
</template>

<script>
  import CarouselCard from '~/components/carousel/CarouselCard.vue';
  import BaseButton from '~/components/base/BaseButton.vue';
  import BaseTooltip from '~/components/base/BaseTooltip.vue';

  export default {
    name: 'trendsreport-carousel-card',
    components: {
      CarouselCard,
      BaseButton,
      BaseTooltip,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      itemType: {
        type: String,
        default: 'article',
      },
      parentSlug: {
        type: String,
        required: true,
      },
      fromIndex: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      isHoveringLock: false,
      isTogglingAlert: false,
      isTogglineFavorite: false,
      dataItem: [],
    }),
    mounted() {
      this.dataItem = this.item;
    },
    updated() {
      this.isTogglineFavorite = false;
      this.isTogglingAlert = false;
    },
    computed: {
      isNew() {
        const parsedTimeStamp = new Date(this.item.publish_date);
        const currentDate = new Date();
        if (parsedTimeStamp >= currentDate) return false;
        const timeDifference = currentDate - parsedTimeStamp;
        const sevenDaysInMilliseconds = 8 * 24 * 60 * 60 * 1000;
        return timeDifference <= sevenDaysInMilliseconds;
      },
      isAnnouncement() {
        return this.itemType === 'announcement';
      },
      isArticle() {
        return this.itemType === 'article';
      },
      isTrendstalk() {
        return this.itemType === 'trendstalk';
      },
      isQA() {
        return this.itemType === 'qa';
      },
      isAcademy() {
        return this.itemType === 'academy';
      },
      isAtAGlanceArticle() {
        return (
          this.itemType === 'article' &&
          this.item.template_name.includes('at-a-glance')
        );
      },
      getCardClass() {
        if (this.isTrendstalk || this.isQA) {
          return 'trendstalk';
        }
        if (this.isAnnouncement) {
          return 'announcement';
        }
        if (this.isAcademy) {
          return 'academy';
        }
        if (this.isArticle) {
          return 'article';
        }

        return null;
      },
      showPopOut() {
        return this.isHoveringLock && (this.isArticle || this.isAcademy);
      },
      showPlayButton() {
        if (this.isTrendstalk || this.isQA) {
          return (
            this.isHoveringLock && (this.item.vimeo_id || this.item.youtube_id)
          );
        }

        return null;
      },
      getDisplayDate() {
        const parsedTimeStamp = new Date(this.item.publish_date);
        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };
        if (this.isAnnouncement) {
          return parsedTimeStamp.toLocaleDateString('en-US', options);
        }

        if (this.isArticle) {
          return parsedTimeStamp.toLocaleDateString('en-US', options);
        }

        if (this.isTrendstalk || this.isQA) {
          const displayDate = parsedTimeStamp.toLocaleDateString(
            'en-US',
            options
          );
          return `Published on ${displayDate}`;
        }

        return null;
      },
      isFavorite() {
        if (this.fromIndex) {
          return this.item.favorite;
        }
        return this.dataItem ? this.dataItem.favorite : this.item.favorite;
      },
      hasNotifications() {
        if (this.fromIndex) {
          return this.item.notifications;
        }
        return this.dataItem
          ? this.dataItem.notifications
          : this.item.notifications;
      },
    },
    methods: {
      openAttachment() {
        if (this.item.attachment) {
          return window.open(this.item.attachment, '_blank');
        }
        return window.open(this.item.url, '_blank');
      },
      async handleAlert() {
        if (this.fromIndex) {
          this.$emit('toggle-alert', this.item);
          return;
        }
        let body = {
          has_notification: this.dataItem
            ? this.dataItem.notifications
            : this.item.notifications,
        };
        await axios.post(
          `/trendsreport/${this.item.id}/tr-toggle-notification`,
          body
        );
        await this.getFreshData();
      },
      async handleFavorite() {
        if (this.fromIndex || this.parentSlug === 'my-favorites') {
          this.$emit('toggle-favorite', this.item);
          return;
        }
        let body = {
          is_favorite: this.dataItem
            ? this.dataItem.favorite
            : this.item.favorite,
        };
        await axios.post(
          `/trendsreport/${this.item.id}/tr-toggle-favorite`,
          body
        );
        await this.getFreshData();
      },
      async getFreshData() {
        let response = await axios.post(
          `/trendsreport/${this.item.id}/tr-refresh-article`
        );
        this.dataItem = response.data;
      },
      playVideo() {
        return;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trendsreport-carousel-card {
    position: relative;
    width: 100%;
    min-width: 300px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    margin: 1rem 0;
    @media (min-width: 1200px) {
      min-width: 373px;
      max-width: 373px;
    }
    &__image-container.trendstalk {
      position: relative;
      height: 125px;
      background: linear-gradient(
        145deg,
        var(--itr-grey-mid),
        var(--itr-grey),
        var(--itr-grey-soft),
        #f1f2f3
      );
      @media (min-width: 768px) {
        height: 156px;
      }
      @media (min-width: 1200px) {
        height: 226px;
      }
    }
    &__image-container.academy {
      position: relative;
      height: 122px;
      background: linear-gradient(
        145deg,
        var(--itr-grey-mid),
        var(--itr-grey),
        var(--itr-grey-soft),
        #f1f2f3
      );
      @media (min-width: 768px) {
        height: 152px;
      }
      @media (min-width: 1200px) {
        height: 222px;
      }
    }
    &__lock-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__play-button-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__play-button-overlay-visible {
      opacity: 1;
      transition: opacity 0.2s ease-in;
    }
    &__play-button-overlay-hidden {
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }
    &__image {
      width: 100%;
      height: 100%;

      object-fit: cover;
      object-position: center;
      cursor: pointer;
    }
    &__title {
      font-size: 18px;
      font-weight: 900;
      color: var(--itr-blue-mid);
      margin-top: 1rem;
      cursor: pointer;
    }
    &__description {
      flex: 1 auto;
      font-size: 14px;
      cursor: pointer;
    }
    &__publish-date {
      font-size: 14px;
      font-weight: 500;
      color: var(--itr-grey-charcoal);
    }
    &__body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 0;
      cursor: pointer;
      .academy {
        margin-top: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        // gap: 1rem;
        @include screen-xl {
          flex-direction: row;
        }
        .insider-carousel-card__title {
          cursor: pointer;
          width: 100%;
          @include screen-xl {
            margin: 0;
          }
        }
        .insider-carousel-card__academy-button {
          white-space: unset;
          line-height: 20px;
          padding: 12px 24px;
          &:hover {
            background-color: $green;
          }
        }
      }
    }
    &__body-content {
      flex: 1 auto;
    }
    &__button {
      font-size: 1rem;
      font-weight: bold;
      color: #fff;
      background-color: #007bff;
      border-color: #007bff;
      display: inline-block;
      padding: 0.5rem 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      border-radius: 0.25rem;
      transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }
    &__link {
      color: var(--itr-green-mid);
      font-size: 1rem;
      font-weight: 700;
    }
    &__new-flag {
      position: absolute;
      right: -20px;
      top: 20px;
      color: #fff;
      background-color: #65a9d2;
      padding: 2px 18px;
      font-weight: 700;
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
      font-size: 20px;
      box-shadow: -4px -4px 4px rgba(0, 0, 0, 0.25);
      &::after {
        position: absolute;
        top: -20px;
        right: 0;
        content: '';
        height: 20px;
        width: 20px;
        border-bottom: solid 10px #3075a4;
        border-left: solid 10px #3075a4;
        border-right: solid 10px transparent;
        border-top: solid 10px transparent;
      }
    }
    &__announcement-title {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &__announcement-title.new {
      margin-right: 65px;
    }
    &__announcement-publish-date {
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 700;
      color: var(--itr-grey-mid);
      cursor: pointer;
    }
    &__announcement-link {
      color: var(--itr-green-mid);
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &__article-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    &__article-content {
      padding: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @media (min-width: 768px) {
        padding: 20px;
      }
    }
    &__article-title {
      font-size: 16px;
      font-weight: 700;
      color: var(--itr-blue-mid);
      margin: 0;
      line-height: 24px;
      cursor: pointer;
    }
    &__article-description {
      font-size: 16px;
      color: var(--itr-black);
      margin-top: 1rem;
      line-height: 20px;
      flex-grow: 1;
      cursor: pointer;
      padding: 0 8px;
      margin-bottom: 0.5rem;
    }
    &__article-image-container {
      position: relative;
      width: 95%;
      margin: auto;
      cursor: pointer;
    }
    &__article-image {
      width: 100%;
      height: 77px;
      object-fit: cover;
      border-radius: 8px;
    }
    &__article-image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      height: 77px;
      width: 100%;
      border-radius: 8px;
      background: linear-gradient(
        to right,
        var(--itr-blue) 31%,
        rgba(196, 196, 196, 0.01) 100%
      );
    }
    &__article-image-play-button {
      position: absolute;
      top: 12px;
      left: 12px;
      height: 55px;
      width: 55px;
    }
    &__article-footer {
      border-top: 2px solid var(--itr-grey);
      display: flex;
      align-items: center;
      height: 58px;
    }
    &__article-date {
      width: 66%;
      text-align: center;
      color: var(--itr-grey-mid);
      font-weight: 700;
      font-style: italic;
      font-size: 16px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__article-icon {
      width: 33%;
      border-left: 2px solid var(--itr-grey);
      text-align: center;
      color: var(--itr-grey-mid);
      height: 100%;
      cursor: pointer;
      &:hover {
        color: var(--itr-white);
        background: var(--itr-grey-mid);
        transition: all 150ms ease;
      }
    }
    &__article-icon.star:hover {
      color: var(--itr-white);
      background: var(--itr-grey-mid);
      border-bottom-right-radius: 6px;
      transition: all 150ms ease;
    }
    &__article-icon.active {
      background: var(--itr-green-mid);
      color: var(--itr-white);
      &:hover {
        background: var(--itr-green-mid);
        color: var(--itr-white);
      }
    }
    &__article-icon.star.active {
      border-radius: 0 0 5px 0;
    }
    &__article-tooltip {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__vimeo-container {
      height: 100%;
      width: 100%;
    }
    &__video {
      height: 100%;
      width: 100%;
    }
  }
  .trendsreport-carousel-card.announcement {
    min-width: 300px;
    max-width: 300px;
    @media (min-width: 1200px) {
      min-width: 490px;
      max-width: 490px;
    }
    // box-shadow: 4px 4px 4px var(--itr-grey-light);
  }
  // .trendsreport-carousel-card.webinar{
  //   width: 222px;
  //   @media(min-width: 768px) {
  //     width: 276px;
  //   }
  //   @media(min-width: 1200px) {
  //     width: 399px;
  //   }
  // }
  .trendsreport-carousel-card.article {
    height: unset;
    border: 2px solid var(--itr-grey);
    border-radius: 8px;
    min-height: 328px;
  }
  .trendsreport-carousel-card.trendstalk {
    min-width: 222px;
    max-width: 222px;
    @media (min-width: 768px) {
      min-width: 276px;
      max-width: 276px;
    }
    @media (min-width: 1200px) {
      min-width: 399px;
      max-width: 399px;
    }
  }
  .trendsreport-carousel-card.academy {
    min-width: 222px;
    max-width: 222px;
    @media (min-width: 768px) {
      min-width: 276px;
      max-width: 276px;
    }
    @media (min-width: 1200px) {
      min-width: 401px;
      max-width: 401px;
    }
  }
</style>
